import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Button } from "react-bootstrap";
import logoImg from '../assets/img/logo222.png';
import '../assets/js/nav.js';
let sessionStorage = window.sessionStorage;
// import logo from '../assets/img/logos/logo2.png';

export default function Nav () {
    const navigate = useNavigate();
    const [admin, setAdmin] = useState(false);
    // logout
    const logoutHandler = () => {
        sessionStorage.removeItem('isLogin');
        window.location.replace("/");
    };
    useEffect(() => {
        setAdmin(sessionStorage.getItem('isLogin'));
    }, []);
    return (
        <>
        {admin ? <button className="btn-normal" onClick={logoutHandler}>관리자 로그아웃</button> : null}
        <header id="header" className="d-flex align-items-center">
            <div className="container d-flex align-items-center justify-content-between">
            <div style={{ float: 'left', padding: '7px 10px', width: '500px' }}>
                <div className="gg-logo">
                    <div className="gg-img"><Link to="/"><img src={logoImg} style={{height: '60px'}}></img></Link></div>
                    <div className="x490 gg-img" style={{marginLeft: '20px'}}><h1 className="aws logo"><Link to="/" className="s490 s1200" style={{fontSize: '26px'}}>주식회사 공간지적측량</Link></h1></div>
                </div>
            </div>
            <nav id="navbar" className="navbar">
                <ul>
                    <li className="dropdown"><Link to="#"><span>회사소개</span> <i className="bi bi-chevron-down"></i></Link>
                        <ul>
                            <li><Link to="/Greetings">인사말</Link></li>
                            <li><Link to="/History">회사연혁</Link></li>
                            <li><Link to="/OrgChart">조직도</Link></li>
                        </ul>
                    </li>
                    <li className="dropdown"><Link to="#"><span>측량사업부</span> <i className="bi bi-chevron-down"></i></Link>
                        <ul>
                            <li><Link to="/BizzIntroSurvey">사업부소개</Link></li>
                            <li><Link to="/SurveyEstimate">견적문의</Link></li>
                        </ul>
                    </li>
                    <li className="dropdown"><Link to="#"><span>설계사업부</span> <i className="bi bi-chevron-down"></i></Link>
                        <ul>
                            <li><Link to="/BizzIntroDesign">사업부소개</Link></li>
                            <li><Link to="/DesignEstimate">견적문의</Link></li>
                        </ul>
                    </li>
                    <li className="dropdown"><Link to="#"><span>주요실적</span> <i className="bi bi-chevron-down"></i></Link>
                        <ul>
                            <li><Link to="/PerfPoint">지적측량</Link></li>
                            <li><Link to="/PerfGeneral">일반측량</Link></li>
                            <li><Link to="/PerfCivil">토목설계</Link></li>
                            <li><Link to="/PerfEtc">기타</Link></li>
                        </ul>
                    </li>
                    <li className="dropdown"><Link to="#"><span>고객센터</span> <i className="bi bi-chevron-down"></i></Link>
                        <ul>
                            <li><Link to="/Notice">공지사항</Link></li>
                            <li><Link to="/Guide">이용안내</Link></li>
                            <li><Link to="/Locate">오시는길</Link></li>
                        </ul>
                    </li>
                </ul>
                <i className="bi bi-list mobile-nav-toggle"></i>
            </nav>
            </div>
        </header>
        </>
    );
}